import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t py-12 mt-auto" style={{ borderColor: "var(--brand-border)" }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-bold mb-3" style={{ fontFamily: "var(--font-heading)" }}>
              GeoForge3D
            </h3>
            <p className="text-sm text-gray-600">
              Custom 3D map art crafted from real geographic data.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-sm">Navigation</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-gray-600 hover:text-gray-900">Home</Link></li>
              <li><Link to="/studio" className="text-sm text-gray-600 hover:text-gray-900">Design Studio</Link></li>
              <li><Link to="/about" className="text-sm text-gray-600 hover:text-gray-900">About</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-600 hover:text-gray-900">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-sm">Support</h4>
            <ul className="space-y-2">
              <li><a href="mailto:hello@geoforge3d.com" className="text-sm text-gray-600 hover:text-gray-900">hello@geoforge3d.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t text-center text-sm text-gray-500" style={{ borderColor: "var(--brand-border)" }}>
          &copy; {new Date().getFullYear()} GeoForge3D. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
